import styles from './template.css';
import template from './template';
import {storeInstance} from '@aofl/store/dist/legacy';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {i18nMixin} from '@aofl/i18n-mixin';

import translations from '../../i18n';
import '../../../../modules/session-sdo';
import '../../../../modules/sdo-licenses';
import {sdoNs} from '@modules/constants-enumerate';

const setTranslations = (ctx) => {
  return {
    licenseDuration: {
      D: (days) => {
        if (days <= 1) {
          return ctx._r(ctx.__('<tt-g3aDkm8B>', '%r1% Day'), days);
        }
        return ctx._r(ctx.__('<tt-zx18KTG9>', '%r1% Days'), days);
      },
      M: (months) => {
        if (months <= 1) {
          return ctx._r(ctx.__('<tt-5ETjvxCH>', '%r1% Month'), months);
        }
        return ctx._r(ctx.__('<tt-kkkOeZAD>', '%r1% Months'), months);
      },
      Y: (years) => {
        if (years <= 1) {
          return ctx._r(ctx.__('<tt-3EwM+SwH>', '%r1% Year'), years);
        }
        return ctx._r(ctx.__('<tt-kSpmStJR>', '%r1% Years'), years);
      },
    }
  };
};

/**
 * @summary LicenseInfo
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('license-info')
class LicenseInfo extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of LicenseInfo.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  @property({type: String, mapState: `${sdoNs.SESSION}.current_role.group_name`, store: storeInstance})
  groupName = '';

  @property({type: Object, mapState: `${sdoNs.LICENSES}.$details`, store: storeInstance})
  info = {};

  @property({type: Object, mapState: `${sdoNs.LICENSES}.currentGroupLicenseCount`, store: storeInstance})
  currentGroupLicenseCount = {};

  @property({type: Object, mapState: `${sdoNs.LICENSES}.childGroupsLicenseCount`, store: storeInstance})
  childGroupsLicenseCount = {};

  @property({type: String})
  product = '';

  @property({type: Number, mapState: `${sdoNs.SESSION}.$levels`, store: storeInstance})
  tierLevels = 0;

  scrollIntoView(id) {
    this.dispatchEvent(new CustomEvent('scroll-to', {
      composed: true,
      detail: {
        id
      }
    }));
  }

  /**
   * @readonly
   */
  static is = 'license-info';

  connectedCallback() {
    super.connectedCallback();

    const t10s = setTranslations(this);
    if (this.info.fixed_duration !== '') {
      const durationSplit = this.info.fixed_duration.match(/P(\d+)([YMD])/);
      const duration = durationSplit[1];
      const term = durationSplit[2];
      this.info.fixed_duration_label = t10s.licenseDuration[term](duration);
    }
  }

  mapStateProperties() {
    this.product = this.info.product;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default LicenseInfo;
